import { clearSession } from "../helpers/global";

/**
 * The single place a session ends. The tenant admin (Sylius, on the store's own
 * subdomain) redirects here on logout too — its session and the portal's live
 * on different origins, so it cannot clear this one itself.
 */
const Logout = () => {
    clearSession();

    window.location.replace("/login");

    return null;
};

export default Logout;
